import _                                       from 'underscore';
import React, { FC }                           from 'react';
import { ClosableHeader, ClosableHeaderProps } from './ClosableHeader';
import { PaddingSize, SemanticUIColor, Size }  from '../../types/componentPropTypes';


export interface ColoredClosableHeaderProps {
    color?:
        SemanticUIColor.PURPLE
        | SemanticUIColor.RED
        | SemanticUIColor.ORANGE
        | SemanticUIColor.TEAL
        | SemanticUIColor.GREEN,
    padding?: PaddingSize | [ PaddingSize, PaddingSize ]
}

const defaultProps: ColoredClosableHeaderProps = {
    color:   SemanticUIColor.PURPLE,
    padding: Size.MD,
}

const ColoredClosableHeader: FC<ColoredClosableHeaderProps & ClosableHeaderProps> = ( _props ) => {

    let { children, padding, color, ...props } = _props;

    let invertedProps = {
        textColor:   'white',
        iconProps:   { inverted: true },
        headerProps: { inverted: true }
    }

    let colorMapping = {
        [ SemanticUIColor.PURPLE ]: { bgColor: SemanticUIColor.PURPLE, ...invertedProps },
        [ SemanticUIColor.RED ]:    { bgColor: SemanticUIColor.RED, ...invertedProps },
        [ SemanticUIColor.ORANGE ]: { bgColor: SemanticUIColor.ORANGE, ...invertedProps },
        [ SemanticUIColor.TEAL ]:   { bgColor: SemanticUIColor.TEAL, ...invertedProps },
        [ SemanticUIColor.GREEN ]:  { bgColor: SemanticUIColor.GREEN, ...invertedProps }
    }

    let colorDefs = colorMapping[ color ];

    return (
        <>
            <ClosableHeader
                containerProps={ {
                    padding,
                    bgColor:   colorDefs.bgColor,
                    textColor: colorDefs.textColor,
                } }
                iconProps={ { ...props.iconProps, ...colorDefs.iconProps } }
                headerProps={ { ...props.headerProps, ...colorDefs.headerProps } }
                divider={ false }
                { ..._.omit( props, 'headerProps', 'iconProps' ) }
            />

            { children }
        </>
    )
};

ColoredClosableHeader.defaultProps = defaultProps;

export { ColoredClosableHeader }
